var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsInt, IsOptional, IsString, Matches, MaxLength, Min } from 'class-validator';
import { PaymentMethod } from '../enums/payment-method.enum.js';
import { CALENDAR_DATE } from './calendar-date.js';
export class RecordPatientInvoicePaymentDto {
    amountCents;
    /** Berlin calendar day the money arrived, `YYYY-MM-DD`. */
    paymentDate;
    method;
    reference;
}
__decorate([
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], RecordPatientInvoicePaymentDto.prototype, "amountCents", void 0);
__decorate([
    Matches(CALENDAR_DATE),
    __metadata("design:type", String)
], RecordPatientInvoicePaymentDto.prototype, "paymentDate", void 0);
__decorate([
    IsEnum(PaymentMethod),
    __metadata("design:type", String)
], RecordPatientInvoicePaymentDto.prototype, "method", void 0);
__decorate([
    IsString(),
    IsOptional(),
    MaxLength(255),
    __metadata("design:type", String)
], RecordPatientInvoicePaymentDto.prototype, "reference", void 0);
//# sourceMappingURL=record-patient-invoice-payment.dto.js.map